module.exports = __webpack_public_path__ + "img/hr-V-R-4-unload-connect.b8052634.png";